import { ReactElement, useEffect, useState } from 'react';
import { useOpenApi } from '../../../core/providers';
import { parseApiError } from '@techshift/react-core';
import { AppToaster } from '../../../core/util';
import { ArcOperator } from '@techshift/callie-private-api-typescript';
import { DeleteArcOperatorForm } from '../delete-arc-operator-form';

export type DeleteArcOperatorProps = {
	operator: ArcOperator;
	hard?: boolean;
	onSuccess?: () => void;
};
export function DeleteArcOperator(props: DeleteArcOperatorProps): ReactElement {
	const { operator, hard, onSuccess } = props;

	const { openApi } = useOpenApi();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		if (error) {
			AppToaster.show({ message: error, intent: 'danger' });
		}
	}, [error]);

	const onSubmit = () => {
		setLoading(true);
		setError('');
		openApi.arc
			.deleteArcOperator(operator.id, { hard })
			.then(() => {
				AppToaster.show({ message: 'ARC operator deleted', intent: 'success' });
				onSuccess?.();
			})
			.catch((error) => {
				parseApiError({
					error,
					unknownError: () => {
						setError('Unknown error');
					},
					requestError: () => {
						setError('Unable to reach server');
					},
					responseError: ({ response }) => {
						if (response.data.message === 'OPERATOR_NOT_FOUND') {
							setError('Cannot delete ARC operator as they do not exist');
						} else {
							setError('Unknown error');
						}
					}
				});
			})
			.finally(() => setLoading(false));
	};
	return (
		<DeleteArcOperatorForm
			id={operator.id}
			hard={hard}
			loading={loading}
			onSubmit={onSubmit}
		/>
	);
}
